import React, { useState } from 'react';
import { SMSPageLayout } from './SMSPageLayout';

export const BroadcastSMS: React.FC = () => {
  const [message, setMessage] = useState('');
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]);

  return (
    <SMSPageLayout title="Broadcast SMS">
      {/* Content will go here */}
    </SMSPageLayout>
  );
}; 